module.exports = __webpack_public_path__ + "fonts/40682817-6626-411d-a1a3-76035e8a5a0f.3ab7c21.woff2";